import { Fragment } from "react";

import * as Icon from "./icons";

export const NativeIcon = ({ name }) => {
  const ResolvedIcon = Icon?.[name] ?? Fragment;

  return <ResolvedIcon />;
};
